import React from 'react';
import { connect } from 'react-redux';

import {
  tokenGetMetadata,
} from '../util/thunks';
import BidOnAuctionForm from './BidOnAuctionForm';
import PlayerCard from './ui/PlayerCard';
import AuctionBidTable from './ui/AuctionBidTable';

class AuctionCard extends React.Component {

  componentWillMount() {
    this.props.tokenGetMetadata(this.props.auction.tokenURI);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  isAuctionEnded = () => {
    // Ended if not in initialized mode AND current block is past endsAtBlock:
    return Number(this.props.auction.endsAtBlock) !== 0 && Number(this.props.auction.endsAtBlock) < this.props.blockNumber;
  }

  getRemainingTime = () => {

    if (Number(this.props.auction.endsAtBlock) === 0) {
      return 'NEW';
    }

    let remainingBlocks = Number(this.props.auction.endsAtBlock) - this.props.blockNumber;

    if (remainingBlocks <= 0) {
      return 'ENDED';
    } else if (remainingBlocks < 5) {
      return '< 1m';
    } else if (remainingBlocks < 10) {
      return '~ 1m';
    } else {
      return `~ ${Math.floor(remainingBlocks / 5)}m`;
    }
  }

  getMetadataAttribute = (trait) => {
    if (!this.props.metadata) {
      return null;
    }

    let attribute = this.props.metadata.attributes.filter(attr => attr.trait_type === trait);
    return attribute[0].value;
  }

  getCurrentBidInEth = () => {
    //TODO: inject properly:
    return window.web3.fromWei(this.props.auction.highestBidAmount, 'ether');
  }

  render() {
    return (
      <PlayerCard player={this.props.metadata}>

        <AuctionBidTable
          isAuctionEnded={this.isAuctionEnded()}
          remainingTime={this.getRemainingTime()}
          rarity={this.getMetadataAttribute('rarity')}
          currentBid={this.getCurrentBidInEth()} />

        {!this.isAuctionEnded() &&
          <BidOnAuctionForm
            auctionIndex={this.props.auction.auctionIndex}
            highestBid={this.props.auction[1]} />
        }
      </PlayerCard>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    metadata: state.tokenMetadata.paths[ownProps.auction.tokenURI],
    blockNumber: state.web3.blockNumber,
  };
};

const mapDispatchToProps = (dispatch) => ({

  tokenGetMetadata: (path) => {
    return dispatch(tokenGetMetadata(path));
  },

});

export default connect(mapStateToProps, mapDispatchToProps)(AuctionCard);



// WEBPACK FOOTER //
// ./src/components/AuctionCard.js